/*###########################################################################
// Reveal
//#########################################################################*/

import { throttle } from '../utilities/_throttleDebounce'
import { inViewport } from '../utilities/_inViewport'

const reveal = {
  config: {
    revealEl: '.reveal',
  },

  elements: {
    revealEls: null
  },

  init() {
    const self = this

    self.elements.revealEls = document.querySelectorAll(self.config.revealEl)

    if (self.elements.revealEls !== null) {
      for (let i = 0; i < self.elements.revealEls.length; i++) {
        const revealEl = self.elements.revealEls[i]
        self.handleRevealEl(revealEl)
      }
    }
  },

  handleRevealEl(revealEl) {
    const self = this

    // Check if in viewport already (scroll saved)
    //
    if (inViewport(revealEl, 0) && !revealEl.classList.contains('revealed')) {
      revealEl.classList.add('revealed')
    }

    window.addEventListener('scroll', throttle(function() {
      if (inViewport(revealEl, 0) && !revealEl.classList.contains('revealed')) {
        revealEl.classList.add('revealed')
      }
    }, 100))
  }
}

window.addEventListener('load', function () {
  reveal.init()
})
